import { render, staticRenderFns } from "./DayGridMonth.vue?vue&type=template&id=2fc84c0e&"
import script from "./DayGridMonth.vue?vue&type=script&lang=js&"
export * from "./DayGridMonth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports